import { render, staticRenderFns } from "./Xxgg.vue?vue&type=template&id=de664754&scoped=true&"
import script from "./Xxgg.vue?vue&type=script&lang=js&"
export * from "./Xxgg.vue?vue&type=script&lang=js&"
import style0 from "./Xxgg.vue?vue&type=style&index=0&id=de664754&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de664754",
  null
  
)

export default component.exports